import React, { useEffect } from 'react'
import "./Verify.css"
import { useParams, useNavigate } from 'react-router-dom'
import api from '../../Common/Api/UserApi'
export default function Verify() {

    const navigate = useNavigate();
    const postToken = async (token) => {
        const { data } = await api.post(`/user/verify/${token}`);
        console.log(data);
        if (data.success) {
            alert("Your account is verified")
            navigate('/auth')
        }
        else {
            alert("Something went wrong please try again , click the button provided in your email")
            navigate('/auth')
        }
    }

    const params = useParams();
    useEffect(() => {
        const token = params.token;
        postToken(token);
    },[])
    
  return (
      <div>
          <h1 className='vericationHeading' >This is a verifcation page , you will soon redirect to home page..</h1>
    </div>
  )
}
